import { toggleDarkModeAndRender } from 'scripts/lib/utils'
export default {
  soompi: [
    // { name: 'Soompi', link: '/', id: 'soompi' },
    // { name: 'Rakuten Viki', image: RakutenVikiLogo, link: 'https://viki.com', id: 'rakuten-viki' }
    // { name: 'Rakuten', link: 'https://rakuten.com', id: 'rakuten' }
  ],
  profile: [
    { name: 'Edit Profile', link: '/es/user/edit', id: 'profile' },
    { name: 'Manage Rakuten ID', link: '/', id: 'rakuten-id' },
    { name: '', id: 'dark-mode', link: '/', callback: toggleDarkModeAndRender, classes: 'navbar-dropdown-link navbar-link active-route dark-mode-link' }
  ],
  primary: [
    { name: 'Explorar',
      subs: {
        updates: [
          { name: 'Lo último', link: '/es/latest', id: 'latest' },
          { name: 'Tendencias', link: '/es/trending', id: 'trending' },
          { name: 'Popular', link: '/es/popular', id: 'popular' },
          { name: 'Último minuto', link: '/es/category/ultimo-minuto', id: 'sub-breaking' }
        ],
        main: [
          { name: 'MV/Teaser', link: '/es/category/mvteaser', id: 'mv-teaser' },
          { name: 'Drama', link: '/es/category/drama', id: 'drama' },
          { name: 'Cultura', link: '/es/category/cultura', id: 'culture-and-society' },
          { name: 'Exclusiva', link: '/es/category/exclusiva', id: 'exclusives' }
        ],
        other: [
          { name: 'Comunidad', link: 'https://www.soompi.com/community', id: 'community' },
          { name: 'Foros', link: 'https://forums.soompi.com/es', id: 'forum' },
          { name: 'Apps', link: '/es/apps', id: 'app' },
          { name: 'Viki', link: 'https://www.viki.com/', id: 'viki' }
        ]
      },
      id: 'explore',
      // point to the dropdown we want to target when this link is clicked
      dropdown: 'expanded-explore',
      link: 'javascript:;',
      // The id of the parent navigation. This is important to prevent parent navigation from collapsing when the subnavigation is clicked
      contextual: 'primary'
    },
    { name: 'Pruebas', link: '/es/category/pruebas', id: 'quiz' },
    { name: 'Video', link: '/es/category/video', id: 'video' },
    { name: 'Celeb', link: '/es/category/celeb', id: 'celeb' },
    { name: 'Estilo', link: '/es/category/estilo', id: 'fashion-beauty' },
    { name: 'TV/Cine', link: '/es/category/tv', id: 'tvfilm' },
    { name: 'Música', link: '/es/category/musica', id: 'music' },
    { name: 'Destacados', link: '/es/category/destacados', id: 'features' }
  ]
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/helpers/navItems/es.js